const getCurrentYear = () => new Date().getFullYear();

const toDateTimeString = (date: Date) =>
    date
        .toLocaleString('ja-JP', {
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
        .replaceAll('/', '-');

export {toDateTimeString};

export default getCurrentYear;
